import React from 'react';
import { PhoneIcon, EnvelopeIcon, MapPinIcon } from '@heroicons/react/24/solid';
import logo from '../assets/logo.png';

const MaintenancePage = () => (
  <div className="min-h-screen bg-navy flex items-center justify-center px-4">
    <div className="max-w-lg text-center">
      <img src={logo} alt="The Kenzie Group logo" className="w-20 mx-auto mb-6" />
      <h1 className="text-2xl sm:text-3xl font-bold text-gold uppercase tracking-wide mb-3">
        The Kenzie Group
      </h1>
      <p className="text-lg font-semibold text-off-white mb-3">
        We're currently making updates to our website.
      </p>
      <p className="text-off-white/80 mb-10">
        Thank you for your patience — please check back soon. In the meantime, you can reach us directly using the information below.
      </p>

      <div className="border-t border-off-white/20 pt-8 space-y-3 text-off-white">
        <div className="flex items-center justify-center space-x-2">
          <PhoneIcon className="h-4 w-4 text-gold" />
          <a href="tel:+19713575202" className="hover:text-gold hover:underline">
            (971) 357-5202
          </a>
        </div>
        <div className="flex items-center justify-center space-x-2">
          <EnvelopeIcon className="h-4 w-4 text-gold" />
          <a href="mailto:office@thekenziegroup.com" className="hover:text-gold hover:underline">
            office@thekenziegroup.com
          </a>
        </div>
        <div className="flex items-center justify-center space-x-2 text-sm text-off-white/70">
          <MapPinIcon className="h-4 w-4 text-gold flex-shrink-0" />
          <span>330 NE Lincoln St. Suite 100, Hillsboro, OR 97124</span>
        </div>
        <div className="flex items-center justify-center space-x-2 text-sm text-off-white/70">
          <MapPinIcon className="h-4 w-4 text-gold flex-shrink-0" />
          <span>415 Boston Post Rd. Suite 3-1177, Milford, CT 06460</span>
        </div>
      </div>
    </div>
  </div>
);

export default MaintenancePage;
